import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import type { Bookmark } from "@circle-react/types/Bookmarks";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { LinkBookmark } from "./LinkBookmark";

export interface BookmarkDropdownItemsProps {
  bookmarks?: Bookmark[];
}

export const BookmarkDropdownItems = ({
  bookmarks = [],
}: BookmarkDropdownItemsProps) => {
  if (bookmarks.length === 0) {
    return (
      <Dropdown.Item onClick={noop}>
        <div className="text-light hover:text-light w-full px-5 py-2 text-sm">
          {t("spaces.bookmarks.folder.no_links")}
        </div>
      </Dropdown.Item>
    );
  }

  return (
    <div className="max-h-[27rem] overflow-auto">
      {bookmarks.map(item => (
        <Dropdown.ItemLink
          key={item.id}
          className="hover:bg-tertiary block w-full rounded-lg p-0 transition-colors duration-75"
        >
          <LinkBookmark bookmark={item} tippyPlacement="right" isInsideFolder />
        </Dropdown.ItemLink>
      ))}
    </div>
  );
};
